{
  "CONTACT_PANEL": {
    "CONFIRM": {
      "YES": "OK",
      "CANCEL": "Zrušit"
    },
    "NOT_AVAILABLE": "Nedostupné",
    "EMAIL_ADDRESS": "E-mailová adresa",
    "PHONE_NUMBER": "Telefonní číslo",
    "WHATSAPP_USERNAME": "Uživatelské jméno WhatsApp",
    "IDENTIFIER": "Identifikátor",
    "COPY_SUCCESSFUL": "Úspěšně zkopírováno do schránky",
    "COPY_NAME": "Kopírovat jméno",
    "COPY_REFERER": "Kopírovat URL",
    "COMPANY": "Společnost",
    "LOCATION": "Poloha",
    "LTV": "LTV",
    "BROWSER_LANGUAGE": "Jazyk prohlížeče",
    "CONVERSATION_LANGUAGE": "Jazyk konverzace",
    "CONVERSATION_TITLE": "Podrobnosti konverzace",
    "VIEW_PROFILE": "Zobrazit profil",
    "BROWSER": "Prohlížeč",
    "OS": "Operační systém",
    "INITIATED_FROM": "Zahájeno od",
    "INITIATED_AT": "Zahájeno v",
    "IP_ADDRESS": "IP adresa",
    "CREATED_AT_LABEL": "Vytvořeno",
    "NEW_MESSAGE": "Nová zpráva",
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "K tomuto kontaktu nejsou přiřazeny žádné předchozí konverzace.",
      "TITLE": "Předchozí konverzace"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Štítky kontaktu",
        "ERROR": "Nelze aktualizovat štítky"
      },
      "CONVERSATION": {
        "TITLE": "Štítky konverzace",
        "ADD_BUTTON": "Přidat štítky"
      },
      "LABEL_SELECT": {
        "TITLE": "Přidat štítky",
        "PLACEHOLDER": "Hledat štítky",
        "NO_RESULT": "Nebyly nalezeny žádné štítky",
        "CREATE_LABEL": "Vytvořit nový štítek"
      }
    },
    "MERGE_CONTACT": "Sloučit kontakt",
    "CONTACT_ACTIONS": "Akce kontaktu",
    "MUTE_CONTACT": "Blokovat kontakt",
    "MUTE_CONTACT_DISABLED": "Nelze použít. Je blokovaná celá doména kontaktu.",
    "UNMUTE_CONTACT": "Odblokovat kontakt",
    "BLOCK_CONTACT_DOMAIN": "Blokovat doménu",
    "UNBLOCK_CONTACT_DOMAIN": "Odblokovat doménu",
    "BLOCK_CONTACT_DOMAIN_DISABLED": "Tuto doménu kontaktu není možné blokovat.",
    "BLOCK_CONTACT_DOMAIN_MESSAGE": "Zablokováním domény zablokujete všechny existující i budoucí kontakty pro danou doménu.",
    "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Odblokováním domény zrušíte blokaci všech kontaktů pro danou doménu (i těch manuálně zablokovaných).",
    "BLOCK_PUBLIC_DOMAIN_TITLE": "Veřejná e-mailová doména",
    "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} je veřejná e-mailová doména, kterou používá mnoho nesouvisejících odesílatelů, proto ji nelze zablokovat celou. Chcete zablokovat jen tuto adresu ({email})?",
    "BLOCK_ONLY_THIS_ADDRESS": "Blokovat jen tuto adresu",
    "MUTED_SUCCESS": "Tento kontakt byl úspěšně zablokován. Jeho konverzace budou brzy vyřešeny na pozadí.",
    "UNMUTED_SUCCESS": "Tento kontakt byl úspěšně odblokován.",
    "OPEN_JARABOT": "Otevřít historii AI odpovědí",
    "TRANSLATE_CONVERSATION": "Přeložit konverzaci",
    "TRANSLATE_INITIATED": "Překlad byl zahájen. U delších konverzací to může chvíli trvat.",
    "TRANSLATE_SUCCESS": "Překlad konverzace byl úspěšně dokončen.",
    "TRANSLATE_ERROR": "Překlad konverzace se nezdařil. Zkuste to prosím znovu.",
    "MOVE_CONVERSATION": "Přesunout konverzaci",
    "MOVE_CONVERSATION_MISSING_EMAIL": "Pro přesun konverzace do e-mailové schránky je vyžadován e-mail kontaktu",
    "MERGE_CONVERSATION": "Sloučit konverzace",
    "CONTACT_DOMAIN_BLOCKED_SUCCESS": "Tato doména byla úspěšně zablokována. Nebudete informováni o žádných budoucích konverzacích.",
    "CONTACT_DOMAIN_UNBLOCKED_SUCCESS": "Tato doména byla úspěšně odblokována.",
    "SEND_TRANSCRIPT": "Poslat přepis",
    "EDIT_LABEL": "Upravit",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Vlastní atributy",
      "CONTACT_LABELS": "Štítky kontaktu",
      "PREVIOUS_CONVERSATIONS": "Předchozí konverzace",
      "NO_RECORDS_FOUND": "Nebyly nalezeny žádné atributy"
    }
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Upravit kontakt",
    "TITLE": "Upravit kontakt",
    "DESC": "Upravit kontaktní údaje"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Smazat kontakt",
    "TITLE": "Smazat kontakt",
    "DESC": "Smazat kontaktní údaje",
    "CONFIRM": {
      "TITLE": "Potvrdit odstranění",
      "MESSAGE": "Opravdu chcete odstranit ",
      "YES": "Ano, odstranit",
      "NO": "Ne, zachovat"
    },
    "API": {
      "SUCCESS_MESSAGE": "Kontakt byl označen ke smazání a bude za okamžik automaticky smazán",
      "ERROR_MESSAGE": "Kontakt nelze smazat. Zkuste to prosím později."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Uložit",
      "CANCEL": "Zrušit",
      "UNSAVED_CHANGES": {
        "TITLE": "Neuložené změny",
        "DESCRIPTION": "Máte neuložené změny. Chcete je před zavřením uložit?",
        "CONFIRM": "Uložit",
        "CANCEL": "Zahodit"
      },
      "AVATAR": {
        "LABEL": "Avatar kontaktu"
      },
      "NAME": {
        "PLACEHOLDER": "Zadejte celé jméno kontaktu",
        "LABEL": "Celé jméno"
      },
      "BIO": {
        "PLACEHOLDER": "Zadejte bio kontaktu",
        "LABEL": "Bio"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "Zadejte e-mailovou adresu kontaktu",
        "LABEL": "E-mailová adresa",
        "DUPLICATE": "Tuto e-mailovou adresu již používá jiný kontakt.",
        "ERROR": "Zadejte prosím platnou e-mailovou adresu."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "Zadejte telefonní číslo kontaktu",
        "LABEL": "Telefonní číslo",
        "HELP": "Telefonní číslo by mělo být ve formátu E.164, např.: +1415555555 [+][kód země][směrové číslo][místní telefonní číslo]",
        "ERROR": "Telefonní číslo by mělo být buď prázdné, nebo ve formátu E.164",
        "DIAL_CODE_ERROR": "Vyberte prosím kód země ze seznamu",
        "DUPLICATE": "Toto telefonní číslo je používáno jiným kontaktem."
      },
      "LOCATION": {
        "PLACEHOLDER": "Zadejte lokaci kontaktu",
        "LABEL": "Poloha"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Zadejte název společnosti",
        "LABEL": "Název společnosti"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Zadejte název země",
        "LABEL": "Název země",
        "SELECT_PLACEHOLDER": "Vybrat",
        "REMOVE": "Odebrat",
        "SELECT_COUNTRY": "Vybrat zemi"
      },
      "CITY": {
        "PLACEHOLDER": "Zadejte název města",
        "LABEL": "Název města"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Zadejte uživatelské jméno na Facebooku",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Zadejte uživatelské jméno na Twitteru",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Zadejte uživatelské jméno na LinkedInu",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Zadejte uživatelské jméno na GitHubu",
          "LABEL": "GitHub"
        }
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Avatar kontaktu byl úspěšně smazán",
        "ERROR_MESSAGE": "Nelze smazat avatar kontaktu. Zkuste to prosím později."
      }
    },
    "SUCCESS_MESSAGE": "Kontakt byl úspěšně uložen",
    "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Zahájit konverzaci",
    "TITLE": "Nová konverzace",
    "DESC": "Zahájit novou konverzaci odesláním nové zprávy.",
    "NO_INBOX": "Nelze najít schránku pro zahájení nové konverzace s tímto kontaktem.",
    "FORM": {
      "TO": {
        "LABEL": "Komu"
      },
      "INBOX": {
        "LABEL": "Schránka",
        "PLACEHOLDER": "Vyberte zdrojovou schránku",
        "ERROR": "Vyberte schránku"
      },
      "SUBJECT": {
        "LABEL": "Předmět",
        "PLACEHOLDER": "Předmět",
        "ERROR": "Předmět nemůže být prázdný"
      },
      "MESSAGE": {
        "LABEL": "Zpráva",
        "PLACEHOLDER": "Napište svou zprávu zde",
        "ERROR": "Zpráva nemůže být prázdná"
      },
      "ATTACHMENTS": {
        "SELECT": "Vybrat soubory",
        "HELP_TEXT": "Přetáhněte soubory sem nebo vyberte soubory k připojení"
      },
      "SUBMIT": "Odeslat zprávu",
      "CANCEL": "Zrušit",
      "SUCCESS_MESSAGE": "Zpráva odeslána!",
      "GO_TO_CONVERSATION": "Zobrazit",
      "ERROR_MESSAGE": "Nelze odeslat! Zkuste to znovu"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Sociální profily"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Přidat atribut kontaktu",
    "COPY_SUCCESSFUL": "Úspěšně zkopírováno do schránky",
    "SHOW_MORE": "Zobrazit všechny atributy",
    "SHOW_LESS": "Zobrazit méně atributů",
    "ACTIONS": {
      "COPY": "Kopírovat atribut",
      "DELETE": "Smazat atribut",
      "EDIT": "Upravit atribut"
    },
    "ADD": {
      "TITLE": "Vytvořit vlastní atribut",
      "DESC": "Přidat vlastní informace k tomuto kontaktu."
    },
    "FORM": {
      "CREATE": "Přidat atribut",
      "CANCEL": "Zrušit",
      "NAME": {
        "LABEL": "Název vlastního atributu",
        "PLACEHOLDER": "Např.: shopify id",
        "ERROR": "Neplatný název vlastního atributu"
      },
      "VALUE": {
        "LABEL": "Hodnota atributu",
        "PLACEHOLDER": "Např.: 11901 "
      },
      "ADD": {
        "TITLE": "Vytvořit nový atribut ",
        "SUCCESS": "Atribut byl úspěšně přidán",
        "ERROR": "Nelze přidat atribut. Zkuste to prosím později"
      },
      "UPDATE": {
        "SUCCESS": "Atribut byl úspěšně aktualizován",
        "ERROR": "Nelze aktualizovat atribut. Zkuste to prosím později"
      },
      "DELETE": {
        "SUCCESS": "Atribut byl úspěšně smazán",
        "ERROR": "Nelze smazat atribut. Zkuste to prosím později"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Přidat atributy",
        "PLACEHOLDER": "Hledat atributy",
        "NO_RESULT": "Nebyly nalezeny žádné atributy"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Vybrat hodnotu",
          "SEARCH_INPUT_PLACEHOLDER": "Hledat hodnotu",
          "NO_RESULT": "Nenalezen žádný výsledek"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Je vyžadována platná hodnota",
      "INVALID_URL": "Neplatná URL",
      "INVALID_INPUT": "Neplatný vstup"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Sloučit kontakty",
    "DESCRIPTION": "Sloučit kontakty pro kombinaci dvou profilů do jednoho, včetně všech atributů a konverzací. V případě konfliktu budou mít přednost atributy primárního kontaktu.",
    "PRIMARY": {
      "TITLE": "Primární kontakt",
      "HELP_LABEL": "Bude smazán"
    },
    "PARENT": {
      "TITLE": "Kontakt ke sloučení",
      "PLACEHOLDER": "Hledat kontakt",
      "HELP_LABEL": "Bude zachován"
    },
    "SUMMARY": {
      "TITLE": "Souhrn",
      "DELETE_WARNING": "Kontakt <strong>{primaryContactName}</strong> bude smazán.",
      "ATTRIBUTE_WARNING": "Kontaktní údaje <strong>{primaryContactName}</strong> budou zkopírovány do <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Něco se pokazilo, prosím zkuste to znova později."
    },
    "FORM": {
      "SUBMIT": "Sloučit kontakty",
      "CANCEL": "Zrušit",
      "CHILD_CONTACT": {
        "ERROR": "Vyberte podřízený kontakt pro sloučení"
      },
      "SUCCESS_MESSAGE": "Kontakt byl úspěšně sloučen",
      "ERROR_MESSAGE": "Nelze sloučit kontakty, zkuste to znovu!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Kontakty",
      "SEARCH_TITLE": "Hledat kontakty",
      "SEARCH_PLACEHOLDER": "Hledat...",
      "MESSAGE_BUTTON": "Zpráva",
      "SEND_MESSAGE": "Odeslat zprávu",
      "SHOW_DETAILS": "Detaily kontaktu",
      "DIAL": "Zavolat",
      "BLOCKING": "Blokování",
      "BLOCK_CONTACT": "Blokovat kontakt",
      "UNBLOCK_CONTACT": "Odblokovat kontakt",
      "BLOCK_CONTACT_MESSAGE": "Zablokování tohoto kontaktu mu zabrání vytvářet nové konverzace a všechny jeho existující konverzace budou vyřešeny. Opravdu chcete tento kontakt zablokovat?",
      "UNBLOCK_CONTACT_MESSAGE": "Odblokování tohoto kontaktu mu umožní vytvářet nové konverzace. Opravdu chcete tento kontakt odblokovat?",
      "BLOCK_CONTACT_DISABLED": "Nelze použít. Je blokovaná celá doména kontaktu.",
      "BLOCK_CONTACT_DOMAIN": "Blokovat doménu kontaktu",
      "UNBLOCK_CONTACT_DOMAIN": "Odblokovat doménu kontaktu",
      "BLOCK_CONTACT_DOMAIN_DISABLED": "Tuto doménu kontaktu není možné blokovat.",
      "BLOCK_CONTACT_DOMAIN_MESSAGE": "Zablokováním domény zablokujete všechny existující i budoucí kontakty pro danou doménu.",
      "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Odblokováním domény zrušíte blokaci všech kontaktů pro danou doménu (i těch manuálně zablokovaných).",
      "BLOCK_PUBLIC_DOMAIN_TITLE": "Veřejná e-mailová doména",
      "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} je veřejná e-mailová doména, kterou používá mnoho nesouvisejících odesílatelů, proto ji nelze zablokovat celou. Chcete zablokovat jen tento kontakt ({email})?",
      "BLOCK_ONLY_THIS_CONTACT": "Blokovat jen tento kontakt",
      "BREADCRUMB": {
        "CONTACTS": "Kontakty"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Přidat kontakt",
          "EXPORT_CONTACT": "Exportovat kontakty",
          "IMPORT_CONTACT": "Importovat kontakty",
          "SAVE_CONTACT": "Uložit kontakt",
          "EMAIL_ADDRESS_DUPLICATE": "Tato e-mailová adresa je již použita pro jiný kontakt.",
          "PHONE_NUMBER_DUPLICATE": "Toto telefonní číslo je již použito pro jiný kontakt.",
          "SUCCESS_MESSAGE": "Kontakt byl úspěšně uložen",
          "ERROR_MESSAGE": "Kontakt nelze uložit. Zkuste to prosím později."
        },
        "BLOCK_SUCCESS_MESSAGE": "Tento kontakt byl úspěšně zablokován. Jeho konverzace budou brzy vyřešeny na pozadí.",
        "BLOCK_ERROR_MESSAGE": "Kontakt nelze zablokovat. Zkuste to prosím později.",
        "UNBLOCK_SUCCESS_MESSAGE": "Tento kontakt byl úspěšně odblokován",
        "UNBLOCK_ERROR_MESSAGE": "Kontakt nelze odblokovat. Zkuste to prosím později.",
        "IMPORT_CONTACT": {
          "TITLE": "Importovat kontakty",
          "DESCRIPTION": "Importovat kontakty pomocí CSV souboru.",
          "DOWNLOAD_LABEL": "Stáhnout vzorový csv soubor.",
          "LABEL": "CSV Soubor:",
          "CHOOSE_FILE": "Vybrat soubor",
          "CHANGE": "Změnit",
          "CANCEL": "Zrušit",
          "IMPORT": "Importovat",
          "SUCCESS_MESSAGE": "O dokončení importu budete informováni e-mailem.",
          "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Exportovat kontakty",
          "DESCRIPTION": "Rychle exportujte csv soubor s komplexními detaily vašich kontaktů",
          "CONFIRM": "Exportovat",
          "SUCCESS_MESSAGE": "Export probíhá. Až bude exportovaný soubor připraven ke stažení, budete informováni e-mailem.",
          "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu"
        },
        "SORT_BY": {
          "LABEL": "Seřadit podle",
          "OPTIONS": {
            "NAME": "Jméno",
            "EMAIL": "E-mail",
            "PHONE_NUMBER": "Telefonní číslo",
            "COMPANY": "Společnost",
            "COUNTRY": "Země",
            "CITY": "Město",
            "LAST_ACTIVITY": "Poslední aktivita",
            "CREATED_AT": "Vytvořeno"
          }
        },
        "ORDER": {
          "LABEL": "Pořadí",
          "OPTIONS": {
            "ASCENDING": "Vzestupně",
            "DESCENDING": "Sestupně"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "Chcete uložit tento filtr?",
            "CONFIRM": "Uložit filtr",
            "LABEL": "Název",
            "PLACEHOLDER": "Zadejte název filtru",
            "ERROR": "Zadejte platný název",
            "SUCCESS_MESSAGE": "Filtr byl úspěšně uložen",
            "ERROR_MESSAGE": "Filtr nelze uložit. Zkuste to prosím později."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Potvrdit smazání",
            "DESCRIPTION": "Opravdu chcete smazat tento filtr?",
            "CONFIRM": "Ano, smazat",
            "CANCEL": "Ne, zrušit",
            "SUCCESS_MESSAGE": "Filtr byl úspěšně smazán",
            "ERROR_MESSAGE": "Filtr nelze smazat. Zkuste to prosím později."
          }
        }
      }
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Zobrazeno {startItem} - {endItem} z {totalItems} kontaktů"
    },
    "FILTER": {
      "NAME": "Název",
      "EMAIL": "E-mailová adresa",
      "PHONE_NUMBER": "Telefonní číslo",
      "IDENTIFIER": "Identifikátor",
      "COUNTRY": "Země",
      "CITY": "Město",
      "CREATED_AT": "Vytvořeno",
      "LAST_ACTIVITY": "Poslední aktivita",
      "REFERER_LINK": "Referer link",
      "BLOCKED": "Zablokovaný",
      "BLOCKED_TRUE": "Ano",
      "BLOCKED_FALSE": "Ne",
      "BUTTONS": {
        "CLEAR_FILTERS": "Vymazat filtry",
        "UPDATE_SEGMENT": "Aktualizovat segment",
        "APPLY_FILTERS": "Použít filtry",
        "ADD_FILTER": "Přidat filtr"
      },
      "TITLE": "Filtrovat kontakty",
      "EDIT_SEGMENT": "Upravit segment",
      "SEGMENT": {
        "LABEL": "Název segmentu",
        "INPUT_PLACEHOLDER": "Zadejte název segmentu"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} dalších filtrů",
        "CLEAR_FILTERS": "Vymazat filtry"
      }
    },
    "CARD": {
      "OF": "z",
      "VIEW_DETAILS": "Zobrazit detaily",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Upravit kontaktní údaje",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Zadejte křestní jméno",
            "ERROR": "Jméno je povinné."
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Zadejte příjmení"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Zadejte e-mailovou adresu",
            "DUPLICATE": "Tuto e-mailovou adresu již používá jiný kontakt.",
            "ERROR": "Zadejte prosím platnou e-mailovou adresu."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Zadejte telefonní číslo",
            "DUPLICATE": "Toto telefonní číslo používá jiný kontakt."
          },
          "CITY": {
            "PLACEHOLDER": "Zadejte název města"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Vybrat zemi"
          },
          "BIO": {
            "PLACEHOLDER": "Zadejte bio"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Zadejte název společnosti"
          }
        },
        "UPDATE_BUTTON": "Aktualizovat kontakt",
        "SUCCESS_MESSAGE": "Kontakt byl úspěšně aktualizován",
        "ERROR_MESSAGE": "Kontakt nelze aktualizovat. Zkuste to prosím později."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Upravit odkazy na sociální sítě",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Přidat Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "Přidat GitHub"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Přidat Instagram"
          },
          "WHATSAPP": {
            "PLACEHOLDER": "Přidat WhatsApp"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "Přidat LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "Přidat Twitter"
          }
        }
      }
    },
    "DETAILS": {
      "CREATED_AT": "Vytvořeno {date}",
      "LAST_ACTIVITY": "Poslední aktivita {date}",
      "DELETE_CONTACT_DESCRIPTION": "Trvale odstranit tento kontakt. Tato akce je nevratná",
      "DELETE_CONTACT": "Smazat kontakt",
      "DELETE_DIALOG": {
        "TITLE": "Potvrdit odstranění",
        "DESCRIPTION": "Opravdu chcete odstranit kontakt {contactName}?",
        "CONFIRM": "Ano, odstranit",
        "API": {
          "SUCCESS_MESSAGE": "Kontakt byl označen ke smazání a bude za okamžik automaticky smazán",
          "ERROR_MESSAGE": "Kontakt nelze smazat. Zkuste to prosím později."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Avatar nelze nahrát. Zkuste to prosím později.",
          "SUCCESS_MESSAGE": "Avatar byl úspěšně nahrán"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Avatar byl úspěšně smazán",
          "ERROR_MESSAGE": "Avatar nelze smazat. Zkuste to prosím později."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Atributy",
        "HISTORY": "Historie konverzací",
        "NOTES": "Poznámky",
        "MERGE": "Sloučit",
        "ORDER_HISTORY": "Objednávky",
        "RETINO": "Retino"
      },
      "HISTORY": {
        "EMPTY_STATE": "K tomuto kontaktu nejsou přiřazeny žádné předchozí konverzace"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Hledat atributy",
        "UNUSED_ATTRIBUTES": "{count} nepoužitý atribut | {count} nepoužité atributy",
        "EMPTY_STATE": "V tomto účtu nejsou k dispozici žádné vlastní atributy kontaktu. Vlastní atribut můžete vytvořit v nastavení.",
        "YES": "Ano",
        "NO": "Ne",
        "TRIGGER": {
          "SELECT": "Vybrat hodnotu",
          "INPUT": "Zadat hodnotu"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Neplatné číslo",
          "REQUIRED": "Je vyžadována platná hodnota",
          "INVALID_INPUT": "Neplatný vstup",
          "INVALID_URL": "Neplatná URL",
          "INVALID_DATE": "Neplatné datum"
        },
        "NO_ATTRIBUTES": "Nebyly nalezeny žádné atributy",
        "API": {
          "SUCCESS_MESSAGE": "Atribut byl úspěšně aktualizován",
          "DELETE_SUCCESS_MESSAGE": "Atribut byl úspěšně smazán",
          "UPDATE_ERROR": "Atribut nelze aktualizovat. Zkuste to prosím později",
          "DELETE_ERROR": "Atribut nelze smazat. Zkuste to prosím později"
        }
      },
      "MERGE": {
        "TITLE": "Sloučit kontakt",
        "DESCRIPTION": "Sloučit dva profily do jednoho, včetně všech atributů a konverzací. V případě konfliktu budou mít přednost atributy primárního kontaktu.",
        "PRIMARY": "Primární kontakt",
        "PRIMARY_HELP_LABEL": "Bude zachován",
        "PRIMARY_REQUIRED_ERROR": "Než budete pokračovat, vyberte kontakt, se kterým chcete sloučit",
        "PARENT": "Kontakt ke sloučení",
        "PARENT_HELP_LABEL": "Bude smazán",
        "EMPTY_STATE": "Nebyly nalezeny žádné kontakty",
        "PLACEHOLDER": "Hledat primární kontakt",
        "SEARCH_PLACEHOLDER": "Hledat kontakt",
        "SEARCH_ERROR_MESSAGE": "Kontakty nelze vyhledat. Zkuste to prosím později.",
        "SUCCESS_MESSAGE": "Kontakt byl úspěšně sloučen",
        "ERROR_MESSAGE": "Kontakty nelze sloučit, zkuste to znovu!",
        "IS_SEARCHING": "Vyhledávání...",
        "BUTTONS": {
          "CANCEL": "Zrušit",
          "CONFIRM": "Sloučit kontakt"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Přidat poznámku",
        "WROTE": "napsal(a)",
        "YOU": "Vy",
        "SAVE": "Uložit poznámku",
        "EMPTY_STATE": "K tomuto kontaktu nejsou přidruženy žádné poznámky. Poznámku můžete přidat zadáním do pole výše."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "V tomto účtu nebyly nalezeny žádné kontakty",
      "SUBTITLE": "Začněte přidávat nové kontakty kliknutím na tlačítko níže",
      "BUTTON_LABEL": "Přidat kontakt",
      "SEARCH_EMPTY_STATE_TITLE": "Vašemu hledání neodpovídají žádné kontakty 🔍",
      "LIST_EMPTY_STATE_TITLE": "V tomto zobrazení nejsou k dispozici žádné kontakty 📋"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "TITLE": "Nová konverzace",
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "Vyhledávání se nepodařilo dokončit. Zkuste to prosím znovu."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "Zobrazit",
      "SUCCESS_MESSAGE": "Zpráva byla úspěšně odeslána!",
      "ERROR_MESSAGE": "Při vytváření konverzace došlo k chybě. Zkuste to prosím později.",
      "NO_INBOX_ALERT": "Nejsou k dispozici žádné schránky pro zahájení konverzace s tímto kontaktem.",
      "CONTACT_SELECTOR": {
        "LABEL": "Komu:",
        "TAG_INPUT_PLACEHOLDER": "Vyhledat kontakt podle jména, e-mailu nebo telefonního čísla",
        "CONTACT_CREATING": "Vytváření kontaktu..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Přes:",
        "BUTTON": "Zobrazit schránky"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Předmět :",
        "SUBJECT_PLACEHOLDER": "Zde zadejte předmět e-mailu",
        "CC_LABEL": "Cc:",
        "CC_PLACEHOLDER": "Vyhledat kontakt podle e-mailové adresy",
        "BCC_LABEL": "Bcc:",
        "BCC_PLACEHOLDER": "Vyhledat kontakt podle e-mailové adresy",
        "BCC_BUTTON": "Bcc"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Napište svou zprávu zde..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Vybrat šablonu",
        "SEARCH_PLACEHOLDER": "Hledat šablony",
        "EMPTY_STATE": "Nebyly nalezeny žádné šablony",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "Šablona WhatsApp: {templateName}",
          "VARIABLES": "Proměnné",
          "BACK": "Zpět",
          "SEND_MESSAGE": "Odeslat zprávu"
        }
      },
      "ACTION_BUTTONS": {
        "SEND": "Odeslat ({keyCode})",
        "MARK_RESOLVED": "Vyřešit novou konverzaci po odeslání",
        "SAVE_DRAFT": "Uložit koncept",
        "CREATE_AS_INTERNAL": "Založit konverzaci s poznámkou",
        "SEND_AND_RESOLVE_ORIGINAL": "Odeslat a vyřešit původní konverzaci ({keyCode})"
      },
      "DISCARD": "Zahodit koncept",
      "DISCARD_MODAL": {
        "TITLE": "Zahodit koncept",
        "DESCRIPTION": "Opravdu chcete zahodit tento koncept?",
        "CONFIRM": "Ano, zahodit",
        "CANCEL": "Zrušit"
      }
    }
  }
}
